import { useState } from 'react';

// The guard against a second click while a request runs, out of MyDesignsScreen's unlike and
// CommunityDesignsScreen's like toggle (backfill PR 32, one copy each): the keys a task is
// running for, which the screens disable their buttons by, and a runner that ignores a key
// whose task is still running.
export const useInFlightGuard = () => {
  const [inFlight, setInFlight] = useState(() => new Set());

  const run = async (key, task) => {
    if (inFlight.has(key)) {
      return; // Already in-flight for this key, ignore (the render's set, as the screens' handlers read it: a click is one event, and React re-renders before the next; a ref would refuse more than the handlers did, left as is, user decision, Oct 2026)
    }

    setInFlight((prev) => new Set(prev).add(key)); // Mark as "in progress"

    try {
      await task();
    } finally {
      // Remove from "in progress" set so user can click again if they want
      setInFlight((prev) => {
        const updated = new Set(prev);
        updated.delete(key);
        return updated;
      });
    }
  };

  return { inFlight, run };
};
